import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.result = this.el.querySelector('.c-result_value')
    this.startValue = this.result.getAttribute('data-value') // kt
    this.value = this.startValue
    this.startDate = new Date('2024-05-01 00:00:00')
    this.kgPS = document.querySelector('.c-co2')
      ? Number.parseFloat(document.querySelector('.c-co2').getAttribute('data-value'))
      : 27.8

    this.updateInterval = null
    this.intervalDuration = 5000

    this.smallInit = false
  }

  play() {
    /* global Odometer */
    this.odometer = new Odometer({
      el: this.result,
      value: '0000000',
      theme: 'minimal',
      format: '( ddd)',
      duration: 3000
    })

    this.odometer.render()

    if (this.el.classList.contains('is-static')) {
      this.odometer.update(Number.parseFloat(this.startValue))
    }
    else {
      this.value = this.getNewStartValue()
      this.result.textContent = this.value

      this.updateInterval = setInterval(() => {
        this.value = Math.round(this.getNewStartValue())
        this.odometer.update(this.value)
      }, this.intervalDuration)
    }
  }

  getNewStartValue() {
    const difference = this.getSecondsDiffBetweenDates(this.startDate, new Date())

    // console.log(difference, 'seconds since', this.startDate, '-> co2 (kg)', difference * this.kgPS);
    // console.log('startValue kt', parseFloat(this.startValue));
    // console.log('newValue kt', (parseFloat(this.startValue) * 1000000 + (difference * this.kgPS)) / 1000000);
    return (Number.parseFloat(this.startValue) * 1000000 + (difference * this.kgPS)) / 1000
  }

  getSecondsDiffBetweenDates(dateInitial, dateFinal) {
    return (dateFinal - dateInitial) / 1000
  }

  showCounter(e) {
    if (this.smallInit === false) {
      if (e.way === 'leave') {
        this.call('show', 'Co2')
        this.smallInit = true
      }
    }
  }

  destroy() {
    clearInterval(this.updateInterval)

    this.odometer?.stopWatchingMutations()
    this.odometer?.resetDigits()
  }
}
